import { useState } from "react";

const VARIATIONS = [
  {
    id: 1,
    label: "버전 A",
    badge: "현재 편집 중",
    duration: "0:47",
    score: 96,
    description: "원본 AI 편집본 · 전체 하이라이트 포함",
    thumbnail: "https://public.readdy.ai/ai/img_res/07f058a7c44bdc673b4bd98bee3a53c5.jpg",
    color: "#00D9FF",
    active: true,
  },
];

export default function ClipVariations({ onSelect }: { onSelect?: (id: number) => void }) {
  const [selected, setSelected] = useState(1);

  const handleSelect = (id: number) => {
    setSelected(id);
    onSelect?.(id);
  };

  return (
    <div className="flex items-center gap-3 h-full">
      <span className="text-gray-500 text-xs font-medium shrink-0 whitespace-nowrap" style={{ fontFamily: "'Inter', sans-serif" }}>
        AI 편집 변형
      </span>
      {VARIATIONS.map((v) => (
        <button
          key={v.id}
          onClick={() => handleSelect(v.id)}
          className={`relative flex items-center gap-3 px-3 py-2 rounded-xl border transition-all cursor-pointer group ${
            selected === v.id
              ? "border-[#00D9FF]/50 bg-[#00D9FF]/8"
              : "border-white/8 bg-[#0F1419] hover:border-white/18"
          }`}
        >
          {/* Thumbnail */}
          <div className="w-8 h-12 rounded-lg overflow-hidden shrink-0 border border-white/10">
            <img src={v.thumbnail} alt={v.label} className="w-full h-full object-cover object-top" />
          </div>

          {/* Info */}
          <div className="text-left min-w-0">
            <div className="flex items-center gap-2 mb-0.5">
              <span className="text-white text-xs font-bold" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                {v.label}
              </span>
              <span
                className="text-xs px-1.5 py-0.5 rounded-full border font-medium"
                style={{
                  color: v.color,
                  borderColor: `${v.color}40`,
                  background: `${v.color}10`,
                  fontFamily: "'JetBrains Mono', monospace",
                  fontSize: "10px",
                }}
              >
                {v.badge}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-gray-400 text-xs" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
                {v.duration}
              </span>
              <span className="text-xs font-bold" style={{ color: v.color, fontFamily: "'JetBrains Mono', monospace" }}>
                {v.score}
              </span>
            </div>
          </div>

          {/* Active indicator */}
          {selected === v.id && (
            <div className="absolute -top-1 -right-1 w-4 h-4 flex items-center justify-center rounded-full bg-[#00D9FF]">
              <i className="ri-check-line text-[#0A0E14] text-xs" />
            </div>
          )}
        </button>
      ))}
    </div>
  );
}
